import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-date-dropdown',
  template: `
  
    <select #monthSelect [(ngModel)]="selectedMonth" class="form-select" (change)="onMonthSelected($event)" style="color: red;border:none;font-size:22px;width:auto;margin:0px 0px 0px 5px">
          <option style="color: red;" *ngFor="let month of months" [value]="month.date">
        {{ month.name }}
      </option>
    </select>
  `,
  styleUrls: ['./date-dropdown.component.css']
})
export class DateDropdownComponent implements OnInit{
  @Input() months: { name: string; date: Date }[] = [];
  @Input() currentYear!: number; // Pass the current year from CalendarComponent
  @Output() onMonthChange = new EventEmitter<Date>();

  selectedMonth: Date = new Date(); // Initially set to current month
  ngOnInit(): void {
    // Set selectedMonth to the current month on component initialization
    const today = new Date();
    this.selectedMonth = new Date(this.currentYear, today.getMonth(), 1); // Set to the 1st day of the current month
  }
  onMonthSelected(event: Event) {
    
    const selectedDateStr = (event.target as HTMLSelectElement).value as string;
    const selectedDate = new Date(selectedDateStr);
    console.log(selectedDate);
    this.onMonthChange.emit(selectedDate);
  }
}
